import React, { FC } from "react";
import cn from "classnames";
import { OnChangeInput } from "src/@types/form";
import { ReactComponent as ImageIcon } from "src/assets/icons/image.svg";
import { ReactComponent as CheckIcon } from "src/assets/icons/check.svg";

interface Props {
  id?: string;
  isUploaded?: boolean;
  placeholder?: string;
  className?: string;
  onChange: OnChangeInput;
  accept?: string;
}
export const FileInput: FC<Props> = ({
  id,
  isUploaded,
  className,
  placeholder,
  onChange,
  accept,
}) => {
  const combinedClassNames = cn(
    "relative flex gap-5 items-center justify-center py-3 px-5 text-xl text-purple-base border border-black-base/20 rounded-20 cursor-pointer",
    {
      "!text-green-base transition-none": isUploaded,
    },
    className
  );

  const Icon = isUploaded ? CheckIcon : ImageIcon;

  return (
    <label className={combinedClassNames} htmlFor={id}>
      <Icon className="w-7 h-7 sm:w-auto sm:h-auto" />
      <span>{placeholder}</span>
      <input
        id={id}
        type="file"
        className="hidden"
        accept={accept}
        onChange={onChange}
      />
    </label>
  );
};
